<header class="header-sticky">
    <app-top-bar></app-top-bar>
</header>
<div class="box-cotizar mx-auto">

    <div class="box-cotizaciones mx-auto mw-100 my-5">
        <div class="text-center mt-4 margin-titulo-cotizaciones">
            <h3 class="px-2 ">Mis Cotizaciones</h3>
        </div>
        <mat-spinner *ngIf="cotizaciones.cargando" class="d-block mx-auto my-3" diameter="20"></mat-spinner>
        <h5 class="text-center" *ngIf="( !cotizaciones.cargando && cotizaciones.registros.length == 0 ) || globals.configuracion.front.usuario.cotizacion_cliente_id == ''">Sin cotizaciones</h5>
        
        <div class="overflow-auto" *ngIf="cotizaciones.registros.length > 0">
            <table mat-table [dataSource]="cotizaciones.registros" class="w-100">

                <ng-container matColumnDef="cotizacion_fecha_hora_formato">
                    <th mat-header-cell *matHeaderCellDef>Fecha</th>
                    <td mat-cell *matCellDef="let element" class="text-nowrap">
                        {{ element.cotizacion_fecha_hora_formato }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="cotizacion_estatus">
                    <th mat-header-cell *matHeaderCellDef>Estatus</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.cotizacion_estatus }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="cantidad_productos">
                    <th mat-header-cell *matHeaderCellDef class="text-end">Cantidad Productos</th>
                    <td mat-cell *matCellDef="let element" class="text-end">
                        {{ element.cantidad_productos }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="cotizacion_total">
                    <th mat-header-cell *matHeaderCellDef class="text-end">Total</th>
                    <td mat-cell *matCellDef="let element" class="text-end">
                        ${{ element.cotizacion_total_format }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['cotizacion_fecha_hora_formato','cotizacion_estatus','cantidad_productos','cotizacion_total']"></tr>
                <tr class="cursor-pointer" mat-row *matRowDef="let row; columns: ['cotizacion_fecha_hora_formato','cotizacion_estatus','cantidad_productos','cotizacion_total']" routerLink="/cotizar/{{ row.cotizacion_id }}"></tr>
            </table>
        </div>
    </div>
    
</div>
  